module.exports = __webpack_public_path__ + "static/media/QNT.a8f8ae85.svg";